<template>
	<div id="banner" ref="FBanner">
		<el-carousel :autoplay="true" :interval="3000" arrow="always" :height="bannerHeight + 'px'" :width="bannerWidth + 'px'">
			<el-carousel-item v-for="(item,index) in imgList" :key="index">
				<img :src="item.url" ref="bannerImg" @load="imgLoad" :style="{width:bannerWidth+'px'}">
				<div class="fbannerUpText" :style="{position:'absolute',top:'35%',left:' 200px',color:'white','font-weight':600,'font-size':(bannerWidth/27)+'px'}" v-html="item.name"></div>
				<button class="fbannerBottomText" @click="toAboutUs" :style="{cursor:'pointer',position:'absolute',top:'55%',left:' 200px',color:'white','font-size':'16px',width:(bannerWidth/12.67)+'px',height:'45px','line-height':'45px','text-align':'center','background-color':'#98273A',border:'0'}">了解更多</button>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import {queryImageByStatus} from "@/api/front";
	export default {
		data() {
			return {
				/* 轮播图变量 */
				imgList: [],
				bannerHeight: '', // 图片父容器高度
				bannerWidth: '', //图片父容器宽度
				// totalWidth:window.screen.width * window.devicePixelRatio,
				totalWidth:window.screen.width,
				windowHeight: document.body.clientHeight,
				windowWidth: document.body.clientWidth
			}
		}, watch: {
			// 监听页面高度
			windowHeight(val) {
				console.log('实时屏幕高度', val, this.windowHeight)
			},
			// 监听页面宽度
			windowWidth(val) {
				window.location.reload()
				console.log('实时屏幕宽度', val, this.windowHeight)
			}
		},
		mounted() {
			this.queryBannerImage()
			window.onresize = () => {
				return (() => {
					this.windowHeight = document.documentElement.clientHeight;
					this.windowWidth = document.documentElement.clientWidth
				})()
			}
				console.log('屏幕',this.$refs.FBanner.offsetWidth)
				this.totalWidth = this.$refs.FBanner.offsetWidth
				this.bannerWidth = this.$refs.FBanner.offsetWidth
		},
		methods: {
			imgLoad() {
				this.$nextTick(() => {
					this.bannerHeight = this.$refs.bannerImg[0].height;
					this.bannerWidth = this.$refs.bannerImg[0].width;
					console.log(this.totalWidth)
				})
			},
			toAboutUs(){
				this.$router.push({
					path: "/aboutUs",
				})
			},
			queryBannerImage(){
				queryImageByStatus('N').then(data => {
					this.imgList=data.data.list
					this.imgLoad();
				}).catch(error =>{
					this.$message.error(error)
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	@keyframes moveLeftToRight{
		from{transform: translateX(300%);}
		to{transform: translateX(0%);}
	}
	.fbannerUpText{
		animation: moveBottomToUp 2s ease-out forwards;
	}
	@keyframes moveBottomToUp{
		from{transform: translateY(1000%);}
		to{transform: translateY(0%);}
	}
	.fbannerBottomText{
		animation: moveBottomToUp 2s ease-out forwards;
	}

/* 定义size-up动画，使元素从初始状态缩放到35倍大小 */
		@keyframes sizeup {
			from {
				transform: scale(1); /* 初始状态，将元素缩小10倍 */
			}
			to {
				transform: scale(1.1); /* 终止状态，将元素放大35倍 */
			}
		}
		/* 将size-up动画添加到img元素中，使图片缩放到35倍大小 */
		img {
				animation: sizeup 2s ease-out forwards; /* 动画持续时间为6秒，并在动画结束后保持最终状态 */
		}
	#banner{
		// border-radius: 0 0 50px 50px;
		// overflow: hidden;
	}
</style>
